<template>
  <div ref="bottomLeft" class="warp"></div>
</template>
<script type="text/javascript" scoped>
  export default {
    name: 'home',
    props: {
      data: {
        type: Object,
        default: () => {}
      },
    },
    data () {
      return {}
    },
    mounted() {
      this.initOption();
    },
    methods: {
      initOption() {
        // initOption 作用： 一次性捕获 echats 图表的挂载点，声明好 echats 图表的 基本配置
        this.chart = this.$echarts.init(this.$refs.bottomLeft);
        this.option = {
          backgroundColor:'transparent',
          legend: {
            top: '0%',
            left: 'center',
            itemWidth: 7,
            itemHeight: 2,
            textStyle:{
              color:'#fff',
            },
          },
          tooltip : {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'

              shadowStyle: {
                color: '#043d39',
                width: 40,
                opacity: 0.4
              },
            },
            backgroundColor:'transparent',
            formatter: function(param){
              var html='';
              return html +='<div style="text-align:left;position:relative;padding: 5px 10px;line-height:22px;background:rgba(0,38,36,0.5);border:1px solid #029e94;border-radius:5px;color:#7a7a7a;box-shadow:0 0 10px 0 rgba(40,157,252,.6);">'+
                '<span style="color:#fff;fontWeight:800;">'+ param[0].name +'</span><br/>'+
                '<span style="color:#a9adad;">流转面积：</span><span style="color: #4cd5ff;">'+param[0].value+'（千公里）</span><br/>'+
                '<span style="color:#a9adad;">同比增长率：</span><span style="color: #4cd5ff;">'+param[1].value+'%</span>'+
                '<i style="position:absolute;bottom:-12px;left:50%;margin-left:-3px;width:0;height:0;border:6px solid transparent;border-top:6px solid #029e94;"></i>'+
                '<i style="position:absolute;bottom:-9px;left:50%;width:0;height:0;margin-left:-2px;border:5px solid transparent;border-top:5px solid rgba(0,38,36,0.5);"></i>'+
                '</div>'
            }
          },
          grid: {
            top: '15%',
            left: '10%',
            right: '10%',
            bottom: '15%'
          },
          dataZoom: [
            {
              type: 'inside',
              xAxisIndex: [0],
              start: 0,
              end: 100
            },
            {
              bottom: 10,
              type: 'slider',
              show: true,
              xAxisIndex: [0],
              start: 0,
              end: 100,
              fillerColor: '#2cc0b6',
              backgroundColor: '#002624',
              height: 10,
              borderRadius: '7px',
              borderColor: '#23a199',
              textStyle: {
                color: 'transparent'
              },
              handleSize: '150%',
              handleStyle: {
                color: 'transparent'
              }
            }
          ],
          xAxis: {
            type : 'category',
            splitLine: {show:false},
            axisLine:{
              lineStyle:{
                color:'#00c2d3'
              }
            },
            axisLabel:{
              textStyle:{
                fontSize:12,
                color:'#fff'
              }
            },
            axisTick:{
              show:false
            },
            data : ['2015','2016','2017','2018']
          },
          yAxis: [
            {
              name: '流转面积：（千公顷）',
              nameTextStyle: {
                color: '#99ffcc'
              },
              type : 'value',
              axisLine:{
                lineStyle:{
                  color:'#00c2d3'
                }
              },
              splitLine: {
                show: false
              },
              axisLabel:{
                textStyle:{
                  fontSize:12,
                  color:'#fff'
                }
              },
              axisTick:{
                show:false
              }
            },{
              min: 0,
              max: 30,
              name: '同比增长率：（%）',
              nameTextStyle: {
                color: '#99ffcc',
              },
              type : 'value',
              splitLine: {
                show:false
              },
              axisLine:{
                lineStyle:{
                  color:'#00c2d3'
                }
              },
              axisLabel: {
                textStyle: {
                  color: '#fff',
                  fontSize: 12
                },
                formatter: '{value}%',
              },
              axisTick:{
                show:false
              }
            }
          ],
          series: [
            {
              name: '流转面积',
              type: 'bar',
              barWidth:15,
              itemStyle: {
                normal: {
                  /*color:new echarts.graphic.LinearGradient(
                   [
                   {offset: 0, color: '#185f6d'},
                   {offset: 1, color: '#18606e'}
                   ]
                   ),*/
                  color: '#185f6d',
                  borderColor: '#00daaf',
                  borderWidth: 1,
                }
              },
              data:[420,300,580,320]
            },
            {
              name: '同比增长率',
              type: 'line',
              yAxisIndex: 1,
              symbolSize:6,
              symbol:'circle',
              itemStyle: {
                normal: {
                  color:"#fd6000",
                  borderWidth: '1',
                  borderColor: '#ebcf3e'
                }
              },
              data:[23,16,30,18]
            }
          ]
        };
        this.chart.setOption(this.option, true);
      }
    }
  }
</script>
<style lang="scss" scoped>
  .warp{
    width: 100%;
    height: 355px;
  }
</style>



// WEBPACK FOOTER //
// src/components/echarts/areatime.vue